import {createI18nScope} from 'common/i18n/scope';

export default createI18nScope(`common.report.retention.util`, {
  'chart-actions.frequency.weighted-average': `Weighted Average Frequency`,
  'chart-actions.retention.weighted-average': `Weighted Average Value`,
  'reports.time-unit.day': `Day`,
  'reports.time-unit.day-of-week': `Day of Week`,
  'reports.time-unit.day_other': `Days`,
  'reports.time-unit.disabled-reason.behavioral': `Not available for behavioral segmentation.`,
  'reports.time-unit.disabled-reason.cohorts': `Not available for cohorts and people timeseries.`,
  'reports.time-unit.disabled-reason.cohorts-over-time-intervals-day': `Not available for cohorts timeseries with time windows over {{max}} days.`,
  'reports.time-unit.disabled-reason.cohorts-over-time-intervals-week': `Not available for cohorts timeseries with time windows over {{max}} weeks.`,
  'reports.time-unit.disabled-reason.day-range': `Not available for time windows over {{max}} days`,
  'reports.time-unit.disabled-reason.hour-range': `Not available for time windows over {{max}} days`,
  'reports.time-unit.disabled-reason.minute-range': `Not available for time windows over {{max}} hours`,
  'reports.time-unit.disabled-reason.minute-range-funnel': `Not available for funnels with time windows over {{max}} hours`,
  'reports.time-unit.disabled-reason.retention': `Not available for retention.`,
  'reports.time-unit.disabled-reason.xau': `Not available when {{xau}} is selected`,
  'reports.time-unit.hour': `Hour`,
  'reports.time-unit.hour-of-day': `Hour of Day`,
  'reports.time-unit.hour_other': `Hours`,
  'reports.time-unit.minute': `Minute`,
  'reports.time-unit.minute_other': `Minutes`,
  'reports.time-unit.month': `Month`,
  'reports.time-unit.month_other': `Months`,
  'reports.time-unit.quarter': `Quarter`,
  'reports.time-unit.quarter_other': `Quarters`,
  'reports.time-unit.second': `Second`,
  'reports.time-unit.second_other': `Seconds`,
  'reports.time-unit.session': `Session`,
  'reports.time-unit.session_other': `Sessions`,
  'reports.time-unit.week': `Week`,
  'reports.time-unit.week_other': `Weeks`,
  'reports.time-unit.x-units': `{{count}} {{timeUnit}}`,
  'reports.time-unit.year': `Year`,
  'reports.time-unit.year_other': `Years`,
});
